// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"vt_a bhb_b bhb_ux"};